import { render, staticRenderFns } from "./ComponentCard.vue?vue&type=template&id=5fb5e258&scoped=true&"
import script from "./ComponentCard.vue?vue&type=script&lang=js&"
export * from "./ComponentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5e258",
  null
  
)

export default component.exports